import { render, staticRenderFns } from "./CRMTableItem.vue?vue&type=template&id=7a17f954&scoped=true"
import script from "./CRMTableItem.vue?vue&type=script&lang=js"
export * from "./CRMTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a17f954",
  null
  
)

export default component.exports